import { AlertElProps } from 'components/Landing/utils/getAlertFromKey';
import { ErrorType } from 'components/Landing/content';
import { MessageEl } from './MessageEl';

export const seCeErrors = (jobId?: string): Record<ErrorType, AlertElProps> => ({
  DEFAULT: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-default-error-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  EMAIL_ALREADY_IN_USE: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-in-use-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INSUFFICIENT_PERMISSIONS: {
    titleId: 'sece-default-error-title',
    message: <MessageEl preTextId="sece-error-insufficient-permissions-pretext" jobId={jobId} />,
    rightActions: [],
  },
  STORE_ALREADY_IN_USE: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-in-use-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  STORE_CONNECTION_ERROR: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-merchant-store-issue-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  OWNER_STILL_ONBOARDING: {
    titleId: 'sece-error-owner-still-onboarding-title',
    message: (
      <MessageEl
        preTextId="sece-error-owner-still-onboarding-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INVALID_INPUT: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-error-invalid-input"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INTERNAL_ERROR: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-error-invalid-input"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MULTIPLE_STORE_COLLECTION: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-error-invalid-input"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MISSING_MERCHANT_ADDRESS: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-merchant-store-issue-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MISSING_MERCHANT_NAME: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-merchant-store-issue-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  ACCOUNT_ALREADY_LINKED: {
    titleId: 'sece-default-error-title',
    message: (
      <MessageEl
        preTextId="sece-error-merchant-store-issue-pretext"
        href="multichannelsupport@amazon.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
});
